import { render, staticRenderFns } from "./StructuredDataFaq.vue?vue&type=template&id=85e40520"
import script from "./StructuredDataFaq.vue?vue&type=script&setup=true&lang=js"
export * from "./StructuredDataFaq.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports